export default __webpack_public_path__ + "static/media/progressBarStep4_vertical.32b0021a.svg";